import {
  LIST_COUNTRY_REQ,
  LIST_COUNTRY_SUCCESS,
  LIST_COUNTRY_FAILURE,
} from "../Constants/countryConstants";
import axiosConfig from "../Core/axiosConfig";

export const COUNTRIES_LIST = () => async (dispatch, getState) => {
  try {
    dispatch({ type: LIST_COUNTRY_REQ });
    const { LoginReducer } = getState();
    let res = await axiosConfig.get(`/country`);
    if (res.data?.Result.includes("Error")) {
      dispatch({ type: LIST_COUNTRY_FAILURE, payload: res.data.Result });
    } else {
      dispatch({ type: LIST_COUNTRY_SUCCESS, payload: res.data.Result });
    }
  } catch (err) {
    dispatch({ type: LIST_COUNTRY_FAILURE, payload: err.message });
  }
};
